module.exports = __webpack_public_path__ + "static/img/BANNER_2.ccc83df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BANNER_2.png
// module id = M2N0
// module chunks = 5